/**
 * Created by asiulik on 25.04.2017.
 */

define(['progressiveImages'], function(ProgressiveImages){

    function Images(){}

    Images.prototype.init = function(){

        this.progressiveImages = new ProgressiveImages({

        });

        this.progressiveImages.init();

        // console.log('this.progressiveImages', this.progressiveImages);

        return this.progressiveImages;

    };

    Images.prototype.getProgressiveInstace = function(){
        return this.progressiveImages;
    };

    return Images;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/progressiveImages.js